import axios, { AxiosRequestConfig } from "axios";

import AppLocalStorage from "../AppLocalStorage";

import { HEADERS } from "./constants";
import { TOKEN_EXPIRED_ERROR_CODE } from "./errorCodes";

let isLoggingOut = false;

const handleLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  AppLocalStorage.removeItem("auth.token");
  AppLocalStorage.removeItem("persist:root");
  window.dispatchEvent(new CustomEvent("bankifi:session-expired"));

  setTimeout(() => {
    isLoggingOut = false;
  }, 2000);
};

type RequestOptions = {
  auth?: boolean;
};

const REQUEST_DEFAULT_OPTIONS: RequestOptions = {
  auth: true,
};

// Create an Axios instance
const axiosInstance = axios.create();

// Handle token expiry globally: catches both HTTP 401 and application-level error code 5005
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.errorCode;

    if (status === 401 || errorCode === TOKEN_EXPIRED_ERROR_CODE) {
      handleLogout();
    }

    return Promise.reject(error);
  },
);

/**
 * HTTP client wrapper around Axios.
 */
const request = async <T = any>(config: AxiosRequestConfig, options = REQUEST_DEFAULT_OPTIONS) => {
  options = { ...REQUEST_DEFAULT_OPTIONS, ...options };
  let headers = config.headers || {};

  // Attach auth token if needed
  if (options.auth) {
    const bankifiToken = AppLocalStorage.getItem("auth.token");
    if (bankifiToken) {
      headers = { ...headers, [HEADERS.AUTH_HEADER]: bankifiToken };
    }
  }

  return axiosInstance.request<T>({ ...config, headers });
};

export default request;
